export enum Addons {
  ProductLibrary = 'ProductLibrary',
  QES = 'QES',
}
